var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5474 4.62532L13.3549 1.42808L14.3297 0.451831C14.6384 0.142683 15.0162 -0.00782255 15.4629 0.000312902C15.9097 0.00844835 16.2956 0.16709 16.6205 0.476237L17.5466 1.37927C17.8715 1.70469 18.0218 2.08706 17.9975 2.52637C17.9731 2.96568 17.8066 3.33992 17.4979 3.64906L16.5474 4.62532ZM0.974811 18C0.698615 18 0.467097 17.9064 0.280258 17.7193C0.0934195 17.5322 0 17.3004 0 17.0237V15.1933C0 15.0794 0.0243703 14.9655 0.0731109 14.8516C0.121851 14.7377 0.194962 14.6319 0.292443 14.5343L12.3314 2.45315L15.5239 5.62598L3.48495 17.7071C3.37122 17.8048 3.25749 17.878 3.14377 17.9268C3.03004 17.9756 2.90819 18 2.77821 18H0.974811Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b7a5dfc246d41b7509d04c0aaa03e0f5.svg";
export { ForwardRef as ReactComponent };